module.exports = __webpack_public_path__ + "static/media/loading3.dcdb168a.svg";